<template>
  <div class="mcp-create-page">
    <page-header :title="$t('ai.mcp.title')" />
    <page-body needMarginBottom>
      <p class="mcp-description">
        {{ $t('ai.mcp.description') }}
        <a-popover
          v-if="defaultTools.length > 0"
          v-model="toolsPopoverVisible"
          :title="$t('ai.mcp.available_tools')"
          placement="bottomRight"
          trigger="click"
          overlayClassName="mcp-tools-popover"
          :overlay-style="{ width: '560px', maxWidth: '70vw', maxHeight: '420px' }">
          <template slot="content">
            <div class="tools-list">
              <div
                v-for="tool in defaultTools"
                :key="tool.name || tool.id"
                class="tool-item">
                <div class="tool-name">{{ tool.name || '-' }}</div>
                <div class="tool-desc">{{ tool.description || '-' }}</div>
              </div>
            </div>
          </template>
          <a href="#" class="mcp-link" @click.prevent>{{ $t('ai.mcp.view_info') }}</a>
        </a-popover>
        <a v-else href="#" class="mcp-link" @click.prevent="handleViewMCPInfo">{{ $t('ai.mcp.view_info') }}</a>
      </p>
      <h2 class="section-title mb-3 mt-3">{{ $t('ai.mcp.section_title') }}</h2>
      <a-tabs v-model="activeTab" class="mcp-tabs">
        <a-tab-pane :key="'builtin'" :tab="$t('ai.mcp.builtin_agent')">
          <p class="mcp-tab-description">
            {{ $t('ai.mcp.agent_description') }}
          </p>
          <list :id="listId" />
        </a-tab-pane>

        <a-tab-pane :key="'cursor'" :tab="$t('ai.mcp.cursor')">
          <mcp-json />
        </a-tab-pane>

        <a-tab-pane :key="'cloudcode'" :tab="$t('ai.mcp.cloud_code')">
          <mcp-json type="claude" />
        </a-tab-pane>
        <a-tab-pane :key="'openclaw'" :tab="$t('ai.mcp.openclaw')">
          <mcp-json type="openclaw" />
        </a-tab-pane>
      </a-tabs>

    </page-body>

    <!-- <page-footer>
      <div slot="right">
        <a-button type="primary" :disabled="activeTab !== 'builtin'" :loading="loading" @click="handleConfirm">{{ $t('common.create') }}</a-button>
        <a-button class="ml-3" @click="handleCancel">{{ $t('common.cancel') }}</a-button>
      </div>
    </page-footer> -->
  </div>
</template>

<script>
import WindowsMixin from '@/mixins/windows'
import List from './components/List'
import McpJson from './components/McpJson'

export default {
  name: 'McpCreate',
  components: {
    List,
    McpJson,
  },
  mixins: [WindowsMixin],
  data () {
    return {
      listId: 'McpList',
      activeTab: 'builtin',
      defaultTools: [],
      toolsPopoverVisible: false,
    }
  },
  created () {
    this.fetchDefaultTools()
  },
  methods: {
    async fetchDefaultTools () {
      try {
        const response = await new this.$Manager('default-mcp-tools', 'v1').list()
        this.defaultTools = response.data
      } catch (error) {
        console.error('Failed to fetch default tools:', error)
      }
    },
    handleViewMCPInfo () {
      if (this.defaultTools.length <= 0) {
        this.$message.info(this.$t('ai.mcp.default_tools_tip'))
      }
    },
  },
}
</script>

<style lang="less" scoped>
.mcp-create-page {
  .mcp-header {
    margin-bottom: 32px;
    padding: 0 24px;
  }

  .mcp-description {
    font-size: 14px;
    color: #666;
    line-height: 1.6;
    margin-bottom: 16px;
  }

  .mcp-title {
    font-size: 24px;
    font-weight: bold;
    color: #000;
    margin-bottom: 0;
  }

  .mcp-link {
    color: #1890ff;
    text-decoration: none;
    cursor: pointer;

    &:hover {
      text-decoration: underline;
    }
  }

  .mcp-tabs {
    ::v-deep .ant-tabs-tab {
      font-size: 14px;
    }
  }

  .mcp-tab-content {
    padding: 24px 0;
  }

  .mcp-tab-description {
    font-size: 14px;
    color: #666;
    line-height: 1.6;
    margin-bottom: 24px;
  }

  .mcp-config-item {
    display: flex;
    align-items: center;
    font-size: 14px;
  }

  .mcp-label {
    margin-right: 8px;
    color: #666;
  }

  .mcp-value {
    color: #000;
    margin-right: 16px;
  }

}

.section-title {
  font-size: 20px;
  font-weight: bold;
  color: #000;
}

</style>

<style lang="less">
.mcp-tools-popover {
  .ant-popover-inner-content {
    max-height: 360px;
    overflow: auto;
  }
  .tools-list {
    max-height: 320px;
    overflow-y: auto;
  }
  .tool-item {
    padding: 10px 0;
    border-bottom: 1px solid #f0f0f0;
    &:hover {
      background: #f5f5f5;
    }
    .tool-name {
      font-weight: 500;
      color: #1890ff;
      margin-bottom: 4px;
    }
  }
  .tool-item:last-child {
    border-bottom: none;
  }
  .tool-name {
    font-weight: 500;
    margin-bottom: 6px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .tool-desc {
    color: #666;
    font-size: 12px;
    line-height: 1.5;
    word-break: break-word;
  }
}
</style>
